import { fallbackValue } from "constants/fallbackConstant";

export const formatCityName = (city) => {
  if (!city) return fallbackValue; 

  const parts = city.split(", "); 
  if (parts.length > 2) {
    return parts.slice(1).join(", "); 
  }
  return city; 
};
